<template>
	<div class="c-card-item" :class="{ 'c-card-item--border': border }" @click.stop="goToReport(item)">
		<div class="c-card-item--title">{{ item.title }}</div>
		<div class="c-card-item--content">
			<span
				class="rate"
				:class="{
					'up': item.rateType === 1,
					'down': item.rateType === 2
				}"
				v-if="item.rating"
			>
				{{ item.rating }}
			</span>
			<span class="info">{{ item.orgName }} · {{ item.publishDate }}</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

export default {
	props: {
		item: {
			type: Object,
			default: () => {
				return {};
			}
		},
		border: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapGetters(['getIrBaseInfo'])
	},
	methods: {
		goToReport(item) {
			this.viewModule('report', item);
		}
	},
	setup() {
		const { viewModule } = useModuleNavigation();
		return {
			viewModule
		};
	}
};
</script>

<style lang="less" scoped>
@import '@/style/mixins';
.c-card-item {
	& + .c-card-item {
		margin-top: 0.14rem;
	}
	&--border {
		.thinner-border-bottom(#e8eaef);
	}
	&--title {
		font-family: 'PingFang SC';
		color: #333;
		font-size: 0.14rem;
		font-weight: 500;
		line-height: 140%; /* 19.6px */
	}
	&--content {
		display: flex;
		align-items: center;
		padding: 0.085rem 0 0.14rem;
		.rate {
			padding: 0.01rem 0.04rem;
			font-size: 0.1rem;
			color: #989898;
			font-weight: 400;
			line-height: 140%;
			background: #e8eaef;
			text-align: center;
			margin-right: 0.08rem;
		}
		.up {
			color: #f76a2b;
			background: linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%), #f76a2b;
		}
		.down {
			color: #30aa5b;
			background: rgba(48, 170, 91, 0.2);
		}
		.info {
			color: #989898;
			font-size: 0.11rem;
			font-weight: 400;
			line-height: 140%; /* 15.4px */
		}
	}
}
</style>
